export class ImageProviderBase {
    constructor(options, authObject) {
        this.host = options.host;
        this.authObject = authObject;
    }
    getImage(url, onSuccess, onError) {
        console.log("Not implemented!");
    }
    getDispmap(url, onSuccess, onError) {
        console.log("Not implemented!");
    }
    static correct_url(url) {
        //Check if url ends with '/' else we add it.
        const suffix = "/";
        if (url.indexOf(suffix, url.length - suffix.length) == -1) {
            url += "/";
        }
        return url;
    }
}
//# sourceMappingURL=ImageProviderBase.js.map